import React from "react";

export const DashboardJobBootstrapContext = React.createContext(null);

export function useDashboardJobBootstrap() {
  return React.useContext(DashboardJobBootstrapContext);
}
